import { render, staticRenderFns } from "./RenxiaoAsideMenu.vue?vue&type=template&id=634b6e62&scoped=true"
import script from "./RenxiaoAsideMenu.vue?vue&type=script&lang=js"
export * from "./RenxiaoAsideMenu.vue?vue&type=script&lang=js"
import style0 from "./RenxiaoAsideMenu.vue?vue&type=style&index=0&id=634b6e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_css-loader@7.1.4_@rspack+core@1.6.4_webpack_588569d094dc83666334fdf605eb9ad3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b6e62",
  null
  
)

export default component.exports